// extracted by mini-css-extract-plugin
module.exports = {"preloader":"dece2e673c--preloader--Xk1OP","spin":"dece2e673c--spin--O7jDs"};